export const environment = {
  production: false,
  version: 1,
  languageKey: 'language',
  langs: ['en', 'de'],
  defaultLang: 'en',
};
